import React, { type FC } from "react";
import Accessories from "./Accessories";
import Packs from "./Packs";
import { useUscLabel, useUscOptionalLabel } from "../../../../utils/labels";
import { useUscSelector } from "../../../../redux/store";
import * as Styles from "./AccessoriesContainer.styles";
import Text from "../../../../../shared-components/toyota/styles/atoms/Text";

const AccessoriesContainer: FC = () => {
    const disclaimerLabel = useUscOptionalLabel("uscPdpAccessoriesDisclaimer");
    const titleLabel = useUscLabel("uscPdpAccessoriesContainerTitle");

    const accessories = useUscSelector((state) => state.accessories.accessoryResults);
    const packs = useUscSelector((state) => state.accessories.packResults);

    const hasAccessoriesOrPacks = accessories.length > 0 || packs.length > 0;

    if (!hasAccessoriesOrPacks) return null;

    return (
        <Styles.Wrapper>
            {hasAccessoriesOrPacks && (
                <>
                    <Text tag="h2" variant="h4">
                        {titleLabel}
                    </Text>
                    <Packs />
                    <Accessories />

                    {disclaimerLabel && (
                        <Text tag="div" variant="body-small-book" color="grey-7">
                            {disclaimerLabel}
                        </Text>
                    )}
                </>
            )}
        </Styles.Wrapper>
    );
};
export default AccessoriesContainer;
